import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fdb0a66a")

_pushScopeId("data-v-fdb0a66a")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置搜索条件")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_search_input = _resolveComponent("search-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "选择段落",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "80%"
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_search_input, {
          modelValue: _ctx.searchName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchName = $event)),
          placeholder: "输入名称进行搜索",
          onSearch: _ctx.handleSearch
        }, null, 8, ["modelValue", "onSearch"]),
        _hoisted_2,
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.resetSearch
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.filteredData,
        stripe: "",
        onRowClick: _ctx.handleRowClick,
        style: {"width":"100%"}
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "名称",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "category",
            label: "分类",
            width: "80"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.category.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "audio",
            label: "音频"
          }, {
            default: _withId((scope) => [
              (scope.row.audio)
                ? (_openBlock(), _createBlock("audio", {
                    key: 0,
                    src: scope.row.audio,
                    controls: ""
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "words",
            label: "文案",
            width: "180"
          }, {
            default: _withId((scope) => [
              _createVNode("pre", null, _toDisplayString(scope.row.words), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "fileSize",
            label: "大小",
            width: "80"
          }, {
            default: _withId((scope) => [
              _createVNode("div", null, _toDisplayString(scope.row.fileSize ? `${(scope.row.fileSize / 1024 / 1024).toFixed(2)}M` : ''), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "tags",
            width: "260",
            label: "标签"
          }, {
            default: _withId((scope) => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.tags, (tag) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: scope.row.id + '-' + tag.id
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "latestVersion",
            label: "版本",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            "show-overflow-tooltip": "",
            prop: "comment",
            label: "变更说明",
            width: "100"
          })
        ]),
        _: 1
      }, 8, ["data", "onRowClick"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})